import { DRIVER_APP_MANUAL_URL, RIO_PRICE_LIST_URL } from '@/lib/constants';

export const USER_MANUAL_TAB_PARAM = 'userManualTab';

export const userManualSections = {
    service: {
        welcome: 'welcome',
        whatsNew: 'whatsNew',
        faq: 'faq',
    },
    findChargingStations: {
        fleetMonitor: 'fleetMonitor',
        driverApp: 'driverApp',
        manEtruck: 'manEtruck',
    },
    functions: {
        overview: 'overview',
        chargingCards: 'chargingCards',
        activateCard: 'activateCard',
        chargingCardAlias: 'chargingCardAlias',
        orderChargingCard: 'orderChargingCard',
        contractInformation: 'contractInformation',
        contactDetails: 'contactDetails',
        invoiceDetails: 'invoiceDetails',
        chargingSessions: 'chargingSessions',
        detailChargingSessions: 'detailChargingSessions',
        invoices: 'invoices',
        download: 'download',
    },
};

export interface IPagesForUserManualDialog {
    keyPage: string;
    imageSrc: string;
    listKeys: string[];
    listSubtitles?: string[];
    permissions?: string;
}

export const userManualFaq = [
    {
        keyFaqPage: 'serviceIntro',
        listKeys: [
            {
                question: 'serviceIntro.whatIsMcg.question',
                description: 'serviceIntro.whatIsMcg.description',
            },
            {
                question: 'serviceIntro.mixedFleet.question',
                description: 'serviceIntro.mixedFleet.description',
            },
            {
                question: 'serviceIntro.additionalServices.question',
                description: 'serviceIntro.additionalServices.description',
            },
        ],
    },
    {
        keyFaqPage: 'gettingStarted',
        listKeys: [
            {
                question: 'gettingStarted.drivers.question',
                description: 'gettingStarted.drivers.description',
            },
            {
                question: 'gettingStarted.amountOfChargingCards.question',
                description: 'gettingStarted.amountOfChargingCards.description',
            },
            {
                question: 'gettingStarted.afterReceivingChargingCard.question',
                description: 'gettingStarted.afterReceivingChargingCard.description',
            },
        ],
    },
    {
        keyFaqPage: 'chargingNetwork',
        listKeys: [
            {
                question: 'chargingNetwork.whereToCharge.question',
                description: 'chargingNetwork.whereToCharge.description',
            },
            {
                question: 'chargingNetwork.reservation.question',
                description: 'chargingNetwork.reservation.description',
            },
        ],
    },
    {
        keyFaqPage: 'chargingProcedure',
        listKeys: [
            {
                question: 'chargingProcedure.chargingDuration.question',
                description: 'chargingProcedure.chargingDuration.description',
            },
        ],
    },
    {
        keyFaqPage: 'pricing',
        listKeys: [
            {
                question: 'pricing.chargingCost.question',
                description: 'pricing.chargingCost.description',
                link: RIO_PRICE_LIST_URL,
            },
            {
                question: 'pricing.costCenter.question',
                description: 'pricing.costCenter.description',
            },
            {
                question: 'pricing.howToPay.question',
                description: 'pricing.howToPay.description',
            },
            {
                question: 'pricing.incorrectInvoice.question',
                description: 'pricing.incorrectInvoice.description',
            },
        ],
    },
    {
        keyFaqPage: 'accountAdmin',
        listKeys: [
            {
                question: 'accountAdmin.mcgAccess.question',
                description: 'accountAdmin.mcgAccess.description',
            },
            {
                question: 'accountAdmin.assignChargingCard.question',
                description: 'accountAdmin.assignChargingCard.description',
            },
            {
                question: 'accountAdmin.lostChargingCard.question',
                description: 'accountAdmin.lostChargingCard.description',
            },
        ],
    },
    {
        keyFaqPage: 'customerSupport',
        listKeys: [
            {
                question: 'customerSupport.report.question',
                description: 'customerSupport.report.description',
            },
        ],
    },
    {
        keyFaqPage: 'technicalDetails',
        listKeys: [
            {
                question: 'technicalDetails.dataProtection.question',
                description: 'technicalDetails.dataProtection.description',
            },
            {
                question: 'technicalDetails.contractualPartner.question',
                description: 'technicalDetails.contractualPartner.description',
            },
        ],
    },
] as IPagesForUserManualFaqDialog[];

export interface IPagesForUserManualFaqDialog {
    keyFaqPage: string;
    listKeys: IPagesForUserManualFaqQuestion[];
    permissions?: string;
}

export interface IPagesForUserManualFaqQuestion {
    question: string;
    description: string;
    permissions?: string;
    link?: string;
}

export const pagesForFunctionSectionOfUserManualDialog = [
    {
        keyPage: userManualSections.functions.overview,
        imageSrc: '/overview.webp',
        listKeys: ['description1', 'description2', 'description3'],
    },
    {
        keyPage: userManualSections.functions.chargingCards,
        imageSrc: '/chargingCards.webp',
        listKeys: ['description1', 'description2', 'description3', 'description4', 'description5'],
    },
    {
        keyPage: userManualSections.functions.activateCard,
        imageSrc: '/activateCard.webp',
        listKeys: ['description1', 'description2', 'description3'],
        permissions: 'emsp-cards.write',
    },
    {
        keyPage: userManualSections.functions.chargingCardAlias,
        imageSrc: '/chargingCardAlias.webp',
        listKeys: ['description1', 'description2', 'description3'],
        permissions: 'emsp-cards.write',
    },
    {
        keyPage: userManualSections.functions.orderChargingCard,
        imageSrc: '/orderChargingCard.webp',
        listKeys: ['description1', 'description2', 'description3', 'description4'],
        permissions: 'emsp-cards.write',
    },
    {
        keyPage: userManualSections.functions.contractInformation,
        imageSrc: '/contractInformation.webp',
        listKeys: ['description1', 'description2', 'description3', 'description4'],
        permissions: 'emsp-contract.read',
    },
    {
        keyPage: userManualSections.functions.contactDetails,
        imageSrc: '/contactDetails.webp',
        listKeys: ['description1', 'description2', 'description3', 'description4', 'description5'],
        permissions: 'emsp-contract.read',
    },
    {
        keyPage: userManualSections.functions.invoiceDetails,
        imageSrc: '/invoiceDetails.webp',
        listKeys: ['description1', 'description2', 'description3'],
        permissions: 'emsp-contract.read',
    },
    {
        keyPage: userManualSections.functions.chargingSessions,
        imageSrc: '/chargingSessions.webp',
        listKeys: [
            'description1',
            'description2',
            'description3',
            'description4',
            'description5',
            'description6',
            'description7',
        ],
    },
    {
        keyPage: userManualSections.functions.detailChargingSessions,
        imageSrc: '/detailChargingSessions.webp',
        listKeys: ['description1', 'description2', 'description3'],
    },
    {
        keyPage: userManualSections.functions.invoices,
        imageSrc: '/invoices.webp',
        listKeys: [
            'description1',
            'description2',
            'description3',
            'description4',
            'description5',
            'description6',
            'description7',
        ],
        permissions: 'emsp-invoices.read',
    },
    {
        keyPage: userManualSections.functions.download,
        imageSrc: '/download.webp',
        listKeys: ['description1', 'description2'],
    },
];

export const pagesForServiceSectionOfUserManualDialog: IPagesForUserManualDialog[] = [
    {
        keyPage: userManualSections.service.welcome,
        imageSrc: '/welcome.webp',
        listSubtitles: ['subtitle1', 'subtitle2'],
        listKeys: [
            'subtitle1.description1',
            'subtitle2.description1',
            'subtitle2.description2',
            'subtitle2.description3',
            'subtitle2.description4',
            'subtitle2.description5',
        ],
    },
    {
        keyPage: userManualSections.service.whatsNew,
        imageSrc: '',
        listKeys: [],
    },
    {
        keyPage: userManualSections.service.faq,
        imageSrc: '',
        listKeys: [],
    },
];

export interface FindChargingStationsPageConfig {
    keyPage: string;
    images: string[];
    subtitles?: string[];
    introText?: string[];
    counterText: Record<number, string[]>;
    footnotes?: string[];
    footnoteLink?: string;
}

export const findChargingStationsManualPages: FindChargingStationsPageConfig[] = [
    {
        keyPage: userManualSections.findChargingStations.fleetMonitor,
        images: [
            '/fleetMonitor1.webp',
            '/fleetMonitor2.webp',
            '/fleetMonitor3.webp',
            '/fleetMonitor4.webp',
            '/fleetMonitor5.webp',
            '/fleetMonitor6.webp',
        ],
        counterText: {
            0: ['description1'],
            1: ['description2', 'description3'],
            2: ['description4', 'description5'],
            3: ['description6', 'description7'],
            4: ['description8'],
            5: ['description9'],
        },
        footnotes: ['', '', '', 'footnote1', 'footnote1', ''],
    },
    {
        keyPage: userManualSections.findChargingStations.driverApp,
        images: ['/driverApp1.webp', '/driverApp2.webp', '/driverApp3.webp'],
        subtitles: ['subtitle1', 'subtitle2', 'subtitle3'],
        counterText: {
            0: ['description1', 'description2', 'description3'],
            1: ['description4', 'description5', 'description6', 'description7', 'description8'],
            2: ['description9', 'description10', 'description11', 'description12', 'description13'],
        },
        footnotes: ['footnote2', 'footnote1', ''],
        footnoteLink: DRIVER_APP_MANUAL_URL,
    },
    {
        keyPage: userManualSections.findChargingStations.manEtruck,
        images: ['/manEtruck1.webp', '/manEtruck2.webp', '/manEtruck3.webp', '/manEtruck4.webp'],
        subtitles: ['subtitle1', 'subtitle2', 'subtitle3', 'subtitle4'],
        introText: ['intro1'],
        counterText: {
            0: ['description1'],
            1: ['description2', 'description3', 'description4'],
            2: ['description5', 'description6'],
            3: ['description7', 'description8'],
        },
    },
];
